import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Home from "./components/Home";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import About from "./components/About";
import Blog from "./components/Blog";
import Footer from "./components/Footer";

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem("darkMode");
    return savedMode ? JSON.parse(savedMode) : true; // Default olarak dark mode açık
  });

  useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify(darkMode));
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    // <div className="App bg-hero-pattern bg-cover bg-center min-h-screen">
    <div className="App bg-gray-100 dark:bg-[#070b0b] bg-cover bg-center min-h-screen transition-colors duration-300">
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <main className="container mx-auto p-4 pt-10">
        <Home darkMode={darkMode} />
        <About />
        <Projects />
        <Skills />
        <Blog />
        <Contact />
        <Footer />
      </main>
    </div>
  );
}

export default App;
